export var FreewheelRequestType;
(function (FreewheelRequestType) {
    FreewheelRequestType["DAI_API"] = "DAI_API";
    FreewheelRequestType["DAI_SDK"] = "DAI_SDK";
    FreewheelRequestType["DAI_SSB"] = "DAI_SSB";
    FreewheelRequestType["IMA"] = "IMA";
})(FreewheelRequestType || (FreewheelRequestType = {}));
